<template>
  <input v-model="value" type="password" :id="id" :name="id" class="input-text" />
</template>

<script setup>
import { ref, watch } from 'vue';
const props = defineProps({id: String, modelValue: String});
const emits = defineEmits(['update:modelValue']);
const value = ref(props.modelValue);
const change = watch(value, (v) => emits('update:modelValue', v));
</script>
